module.exports = __webpack_public_path__ + "media/wood-hit-hard-trimmed.1a4cdf24.wav";